import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addCrewMembers } from "../services/content";
import "./ui/ui.css";
import "./crew.css";

const Crewmembers = ({
  generalContentObject,
  url,
  getContent,
  getContentGC,
}) => {
  const dispatch = useDispatch();

  const [crewMemList, setCrewMemList] = useState("");
  useEffect(() => {
    // console.log(generalContentObject[0]?.crew_members);
    setCrewMemList(generalContentObject[0]?.crew_members);
  }, [generalContentObject]);
  const { t } = useTranslation();
  // handling data
  const [inputs, setInputs] = useState({});
  const [inputList, setInputList] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    if (inputs.member_name && inputs.member_role) {
      setInputList([...inputList, inputs]);
      setInputs({});
    } else {
      toast.error("Please fill in all fields for all Production team!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
    }
  };

  const handleDelete = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle submit, when user clicks on submit all the data is posted to APi
  const handleSubmit = async () => {
    if (inputList.length === 0) {
      toast.error("Please add Production team first!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
    } else {
      const data = {
        crew_members: inputList,
      };

      await addCrewMembers(url, generalContentObject[0]?._id, data);
      setInputList([]);
      toast.success("Production team Added Successfully!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
      await getContent(generalContentObject[0]?._id).then((data) => {
        dispatch(getContentGC(data));
        // console.log(" data>>>>>>>>>>>>", data);
      });
      setCrewMemList(generalContentObject[0]?.crew_members);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();

    setInputList([]);
  };

  const initial = (name) => (name || "?").charAt(0).toUpperCase();

  return (
    <div className="crew">
      {crewMemList?.length > 0 ? (
        <ul className="crew-list">
          {crewMemList.map((item, index) => (
            <li key={item?._id || index}>
              <span className="crew-avatar" aria-hidden="true">
                {initial(item.member_name)}
              </span>
              <span className="crew-text">
                <strong>{item.member_name}</strong>
                <span>{item.member_role}</span>
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="ui-hint crew-empty">{t("No production team yet")}</p>
      )}

      <form className="crew-add" onSubmit={handleAddClick}>
        <div className="ui-field">
          <label htmlFor="crew-name">{t("Member Name")}</label>
          <input
            id="crew-name"
            className="ui-input"
            name="member_name"
            onChange={handleInputChange}
            value={inputs.member_name || ""}
          />
        </div>
        <div className="ui-field">
          <label htmlFor="crew-role">{t("Member Role")}</label>
          <input
            id="crew-role"
            className="ui-input"
            name="member_role"
            placeholder={t("e.g. Director")}
            onChange={handleInputChange}
            value={inputs.member_role || ""}
          />
        </div>
        <button type="submit" className="ui-btn ui-btn-secondary crew-add-btn">
          <i className="ri-add-line" aria-hidden="true"></i>
          {t("Add")}
        </button>
      </form>

      {inputList?.length > 0 && (
        <div className="crew-pending">
          <span className="ui-label">{t("To be saved")}</span>
          <ul className="crew-list">
            {inputList.map((item, index) => (
              <li key={index} data-pending="">
                <span className="crew-avatar" aria-hidden="true">
                  {initial(item.member_name)}
                </span>
                <span className="crew-text">
                  <strong>{item.member_name}</strong>
                  <span>{item.member_role}</span>
                </span>
                <button
                  type="button"
                  className="ui-icon-btn"
                  data-tone="danger"
                  aria-label={t("Delete")}
                  title={t("Delete")}
                  onClick={() => handleDelete(index)}
                >
                  <i className="ri-close-line" aria-hidden="true"></i>
                </button>
              </li>
            ))}
          </ul>
          <div className="crew-actions">
            <button type="button" className="ui-btn ui-btn-secondary" onClick={handleCancel}>
              {t("cancel")}
            </button>
            <button type="button" className="ui-btn" onClick={() => handleSubmit()}>
              {t("Save the team")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Crewmembers;
